// extracted by mini-css-extract-plugin
export var alignDiscLeft = "r_rQ d_fp d_bG d_dv";
export var alignLeft = "r_qh d_fp d_bG d_dv";
export var alignDiscCenter = "r_rR d_fq d_bD d_dw";
export var alignCenter = "r_bP d_fq d_bD d_dw";
export var alignDiscRight = "r_rS d_fr d_bH d_dx";
export var alignRight = "r_qj d_fr d_bH d_dx";
export var footerContainer = "r_rT d_dW d_bW";
export var footerContainerFull = "r_rV d_dT d_bW";
export var footerHeader = "r_kf d_kf";
export var footerTextWrapper = "r_rW d_w";
export var footerDisclaimerWrapper = "r_km d_km d_ck";
export var badgeWrapper = "r_rX d_w d_bz d_bP d_bF d_bJ";
export var verticalTop = "r_rY d_bz d_bJ d_bN d_bL";
export var wide = "r_rZ d_cy";
export var right = "r_r0 d_bK";
export var line = "r_fk d_fl d_cv";
export var badgeDisclaimer = "r_r1 d_bC d_bP d_bJ";
export var badgeContainer = "r_r2 d_bz d_bH d_bP";
export var badge = "r_r3";
export var padding = "r_r4 d_c7";
export var end = "r_r5 d_bH";
export var linkWrapper = "r_r6 d_dB";
export var link = "r_mC d_dB";
export var colWrapper = "r_r7 d_cx";
export var consent = "r_f d_f d_bC d_bP";
export var disclaimer = "r_r8 d_bz d_bJ";
export var media = "r_r9 d_bx d_dy";
export var itemRight = "r_sb";
export var itemLeft = "r_sc";
export var itemCenter = "r_sd";
export var exceptionWeight = "r_sf y_tn";